<template>
    <div class="gst-form-row d-flex flex-grow-1 mx-n2 mb-4">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'FilterFormRow',
};
</script>
